import type { CommentResponse } from '@erp/rpc';

export function commentIsEditableBy(
  comment: Pick<CommentResponse, 'authorType' | 'authorUserId'>,
  currentUserId: string | undefined,
): boolean {
  return (
    comment.authorType === 'user' &&
    currentUserId !== undefined &&
    comment.authorUserId === currentUserId
  );
}

export function noteRowModifyFlags(params: {
  comment: Pick<CommentResponse, 'authorType' | 'authorUserId'>;
  currentUserId: string | undefined;
  canUpdate: boolean;
  canDelete: boolean;
}): { showEdit: boolean; showDelete: boolean } {
  const canModify = commentIsEditableBy(params.comment, params.currentUserId);
  return {
    showEdit: canModify && params.canUpdate,
    showDelete: canModify && params.canDelete,
  };
}
